import { CHAIN_ID_TO_NAMES } from "@/constants/mod-perms-tool.constants";

export default function resolveChainName(chainId: number | undefined): string | number {
  if (!chainId) return "-";
  const chainName = CHAIN_ID_TO_NAMES[chainId];
  return chainName || chainId;
}
